<template>
	<div class="keyword-cls">
		<div v-show="list.length != 0" id="chart"></div>
		<el-divider v-if="list.length != 0"></el-divider>
		<div class="basis-page-cls" v-loading="loading">
			<section class="basis-cls_filter" style="border-bottom: none;">
				<span class="label-cls">时间：</span>
				<el-select v-model="listQuery.dateType" @change="getList" size="mini">
					<el-option
						v-for="item in [
							{id: 'date', name: '天'},
							{id: 'week', name: '周'},
							{id: 'month', name: '月'}
						]"
						:key="item.id"
						:label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
				<el-date-picker
					v-model="listQuery.date"
					:type="listQuery.dateType"
					placeholder="选择日期" 
					size="mini"
					:picker-options="{firstDayOfWeek: 1}"
					:format="listQuery.dateType === 'week' ? 'yyyy 第 WW 周' : ''"
					@change="getList">
				</el-date-picker>
				<el-divider direction="vertical"></el-divider>
				<span class="label-cls">类型：</span>
				<el-radio-group v-model="listQuery.type" size="mini" @change="getList">
					<el-radio-button v-for="(item, index) in [{id: '', name: '全部'}, {id: '1', name: '知识'}, {id: '2', name: '流程'}]" :key="index" :label="item.id">{{item.name}}</el-radio-button>
				</el-radio-group>
				<!-- <el-button @click.stop="handleExport" size="mini" style="float: right">导出</el-button> -->
			</section>
			<section class="basis-cls_table">
				<div class="table">
					<table-pagination
				pagination
				:data="list"
				:column="column"
				:total="total"
				:page.sync="listQuery.pageNum"
				:limit.sync="listQuery.pageSize"
				@pagination="getList" />
				</div>
			</section>
		</div>
	</div>
</template>
<script>
import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";
export default {
	name: "VisitShow",
	data() {
		return {
			column: [
				{
                    label: '序号',
                    width: 50,
					align: 'center',
                    render: (h, scope) => {
                        return <span>{((this.listQuery.pageNum - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
                    }
                },
				{ label: '关键词', prop: 'search', minWidth: 180 },
				{ 
					label: '搜索方式', 
					width: 180,
					render: (h, scope) => {
						return <el-tag size="mini" type={scope.row.mode == '1' ? '' : 'warning'}>{scope.row.mode == '1' ? '全文' : '智能'}</el-tag>
                    } 
				},
				{ 
					label: '类型', 
					width: 180,
					render: (h, scope) => {
                        return <el-tag size="mini" type={scope.row.type == '1' ? 'warning' : ''}>{scope.row.type == '1' ? '知识' : '流程'}</el-tag>
                    } 
				},
				{ label: '搜索量', prop: 'num', width: 100, align: 'center' }
            ],
			listQuery: {
				pageNum: 1,
				pageSize: 50,
				projectId: '',
				type:'',
				dateType: 'month',
				date: new Date(),
				start_date: '',
				end_date: ''
			},
			total: 0,
			list: [],
			loading: false,
		};
	},
	mounted() {
		this.getList();
	},
	methods: {
		getList() {
			this.loading = true;
			this.listQuery.projectId = this.$store.getters.userInfo.brandIdentify;
			this.$api.apiPostKnowledgeQaSearchList(this.listQuery).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.list = response.data?.rows ? response.data?.rows : [];
				this.total = response.data?.total ? response.data?.total : 0;
				const chart = echarts.init(document.getElementById('chart'));
				const data = this.list.map(val => ({
					name: val.search,
					value: val.num,
					textStyle: {
						color: this.randomColor()
					}
				}));
				chart.setOption({
					tooltip: {
						show: true
					},
					series: [{
						type: 'wordCloud',
						shape: 'circle',
						left: 'center',
						top: 'center',
						right: null,
						bottom: null,
						width: '100%',
						height: '100%',
						size: ["80%", "80%"],
						sizeRange: [20, 60],
						rotationRange: [-45, 90],
						textPadding: 0,
						autoSize: {
							enable: true,
							minSize: 14,
						},
						rotationStep: 45,
						gridSize: 10,
						drawOutOfBound: false,
						textStyle: {
							normal: {
								fontWeight: 'normal'
							},
							emphasis: {
								shadowBlur: 10,
								shadowColor: '#333',
								color: '#000'
							}
						},
						data: data
					}]
				});
				this.loading = false;
			});
		},
		randomColor() {
			return 'rgb(' + [
				Math.round(Math.random() * 255),
				Math.round(Math.random() * 255),
				Math.round(Math.random() * 255)
			].join(',') + ')';
		}
	}
};
</script>

<style lang="scss" scoped>
#chart {
	width: 800px;
	height: 350px;
	margin: 0 auto 30px;
}
.basis-cls_filter {
	::v-deep .el-select input {
		width: 60px;
		background: #f5f7fa;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		border-right: none;
	}

	::v-deep .el-date-editor input {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

	.label-cls {
		font-size: 14px;
		color: #838A9D;
	}
}
</style>